import { render, staticRenderFns } from "./AddEditTask.vue?vue&type=template&id=38bdde11&scoped=true&"
import script from "./AddEditTask.vue?vue&type=script&lang=js&"
export * from "./AddEditTask.vue?vue&type=script&lang=js&"
import style0 from "./AddEditTask.vue?vue&type=style&index=0&id=38bdde11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bdde11",
  null
  
)

export default component.exports